import type { Sound } from "@akina/domain";

export const cmsEndpoints = () => ({
  short: "care/session-v2/education-templates",
  treatmentTemplate: (slug: string) => `care/treatment-templates/${slug}`,
  treatmentTemplates: `care/treatment-templates`,
  portalLegalPage: (slug: string) => `portal/settings/legal-pages/${slug}`,
  careLegalPage: (slug: string) => `care/profile-and-settings/legal-pages/${slug}`,
  sound: (slug: Sound["type"]) => `care/sounds/${slug}`,
  exercise: (slug: string) => `care/session-v2/exercise-templates/${slug}`,
  exerciseNames: "care/session-v2/exercise-templates",
  ifuLanguages: "care/profile-and-settings/ifu-language-options",
  releaseNotesCare: "shared/release-notes/care",
  releaseNotesPortal: "shared/release-notes/portal",
  image: (slug: string) => `care/images/${slug}`,
});
